// extracted by mini-css-extract-plugin
export var btnContainer = "RegisterLayout-module--btnContainer--61fd2";
export var headerWrapper = "RegisterLayout-module--headerWrapper--e56cc";
export var mainContainer = "RegisterLayout-module--mainContainer--09616";
export var nav = "RegisterLayout-module--nav--a598e";
export var navlinks = "RegisterLayout-module--navlinks--cf067";
export var noUser = "RegisterLayout-module--noUser--b4853";
export var noUserButton = "RegisterLayout-module--noUserButton--c476d";
export var signTitle = "RegisterLayout-module--signTitle--deef5";
export var withTitle = "RegisterLayout-module--withTitle--cb867";
export var withUser = "RegisterLayout-module--withUser--82e10";